document.addEventListener('DOMContentLoaded', function () {
    const balanceForm = document.getElementById('balanceForm');
    const rechargeButton = document.getElementById('rechargeButton');
    const searchInput = document.getElementById('searchNumber');
    const submitButton = document.getElementById('submitButton');
    const loadingIndicator = document.getElementById('loadingIndicator');
    const errorMessage = document.getElementById('errorMessage');
    const resultContainer = document.getElementById('resultContainer');
    const additionalQueriesContainer = document.getElementById('additionalQueriesContainer');
    const settings = window.gpsBalanceChecker;

    const url = new URL(window.location.href);
    const lookupValues = url.searchParams.get('lookup')?.split(',').filter(Boolean) || [];

    function createCopyUrlButton() {
        const existingButton = document.getElementById('copyUrlButton');
        if (!existingButton) {
            const copyButtonDiv = document.createElement('div');
            copyButtonDiv.className = 'copy-url-container';
            copyButtonDiv.innerHTML = `
            <button class="button sec-btn form__btn" id="copyUrlButton" style="margin: 18px 0 0 0;background-color: orangered">Copy URL</button>
        `;
            const balanceCheckerForm = document.querySelector('.balance-checker-form');
            balanceCheckerForm.appendChild(copyButtonDiv);

            document.getElementById('copyUrlButton').addEventListener('click', () => {
                const currentUrl = window.location.href;
                navigator.clipboard.writeText(currentUrl).then(() => {
                    alert('URL copied to clipboard!');
                }).catch(err => {
                    showError('Failed to copy URL: ' + err.message);
                });
            });
        }
    }


    function updateUrlWithLookup(searchValue) {
        const url = new URL(window.location.href);
        const existingLookups = url.searchParams.get('lookup')?.split(',').filter(Boolean) || [];

        // Only add if not already present
        if (!existingLookups.includes(searchValue)) {
            existingLookups.push(searchValue);
            url.searchParams.set('lookup', existingLookups.join(','));
            window.history.replaceState({}, '', url);
        }
    }

    function isNumeric(str) {
        return /^\d+$/.test(str);
    }

    // Process lookup values
    if (lookupValues.length > 0) {

        const firstValidNumber = lookupValues.find(val => isNumeric(val));
        if (firstValidNumber) {
            searchInput.value = firstValidNumber;
            triggerBalanceCheck(firstValidNumber, resultContainer, rechargeButton);
            createCopyUrlButton(); // Add this line
        }

        // Check balance for additional valid numbers
        lookupValues.slice(1).forEach(val => {
            if (isNumeric(val)) {
                const queryDiv = document.createElement('div');
                queryDiv.className = 'query-group';
                const uniqueId = Date.now().toString() + Math.floor(Math.random() * 1000).toString();
                queryDiv.innerHTML = `
    <div class="form__linput additional-query">
        <label class="form__label" for="searchNumber${uniqueId}">Enter another phone number</label>
        <input class="form__input sim-input" id="searchNumber${uniqueId}" type="text" name="searchNumber" value="${val}" readonly>
        <button class="button pri-btn form__btn" type="button" data-index="${uniqueId}">Check Balance</button>
    </div>
    <div class="results-container additional-result card-wrapper" id="resultContainer${uniqueId}"></div>
`;
                additionalQueriesContainer.appendChild(queryDiv);

                const resultContainer = queryDiv.querySelector(`#resultContainer${uniqueId}`);
                const rechargeButton2 = queryDiv.querySelector(`button[data-action="recharge"]`);
                triggerBalanceCheck(val, resultContainer, null);

                queryDiv.querySelectorAll('button').forEach(button => {
                    button.addEventListener('click', handleAdditionalQuery);
                });
            }
        });
    }

    function triggerBalanceCheck(searchValue, resultContainer) {
        if (!searchValue || !isNumeric(searchValue)) {
            showError(settings.emptyInputError);
            return;
        }

        submitButton.disabled = true;
        loadingIndicator.style.display = 'block';

        fetch(`${settings.apiEndpoint}?search=${searchValue}`)
            .then(response => response.json())
            .then(data => {
                loadingIndicator.style.display = 'none';
                submitButton.disabled = false;

                if (data.success) {
                    resultContainer.style.display = 'block';
                    resultContainer.innerHTML += `
        <div class="card">
            ${data.data ? `
                <div class="gps-check-data-row"><span class="gps-check-data-label">${settings.numberLabel}:</span><span class="gps-check-data-value">${data.data.Inum}</span></div>
                <div class="gps-check-data-row"><span class="gps-check-data-label">${settings.balanceLabel}:</span><span class="gps-check-data-value">${data.data.Balance} ${data.data.Currency}</span></div>
                <button class="button sec-btn form__btn" type="button" data-action="recharge">Recharge SIM</button>
            ` : ''}
        </div>
        <hr class="result-divider">
    `;
                    if (data.data) {
                        resultContainer.querySelector('button[data-action="recharge"]').addEventListener('click', () => {
                            window.open(`https://beachsim.de/products/gps-sim-card-recharge?simCode=${searchValue}`, '_blank');
                        });
                    }
                    createCopyUrlButton();
                } else {
                    showError(data.message);
                }
            })
            .catch(error => {
                loadingIndicator.style.display = 'none';
                submitButton.disabled = false;
                showError(settings.fetchErrorPrefix + error.message);
            });
    }




    searchInput.addEventListener('input', function(e) {
        this.value = this.value.replace(/[^0-9]/g, '');
    });

    searchInput.addEventListener('paste', function(e) {
        e.preventDefault();
        const pastedData = (e.clipboardData || window.clipboardData).getData('text');
        this.value = pastedData.replace(/[^0-9]/g, '');
    });


    function createNewQueryForm() {
        // Check if there's an empty input box
        const existingInputs = additionalQueriesContainer.querySelectorAll('.form__input.sim-input');
        const hasEmptyInput = Array.from(existingInputs).some(input => !input.value.trim());

        if (!hasEmptyInput) {
            const queryDiv = document.createElement('div');
            queryDiv.className = 'query-group';
            const uniqueId = Date.now().toString() + Math.floor(Math.random() * 1000).toString();
            queryDiv.innerHTML = `
    <div class="form__linput additional-query">
        <label class="form__label" for="searchNumber${uniqueId}">Enter another phone number</label>
        <input class="form__input sim-input" id="searchNumber${uniqueId}" type="text" name="searchNumber" placeholder="e.g. 37281402782" required>
        <button class="button pri-btn form__btn" type="button" data-index="${uniqueId}">Check Balance</button>
    </div>
    <div class="results-container additional-result" id="resultContainer${uniqueId}"></div>
`;
            additionalQueriesContainer.appendChild(queryDiv);
            queryDiv.querySelectorAll('button').forEach(button => {
                button.addEventListener('click', handleAdditionalQuery);
            });
        }
    }

    function handleAdditionalQuery(e) {
        e.preventDefault();
        const input = this.parentElement.querySelector('input');
        const searchValue = input.value.trim();
        const resultContainer = this.parentElement.nextElementSibling;

        if (!searchValue) {
            showError(settings.emptyInputError);
            return;
        }

        submitButton.disabled = true;
        loadingIndicator.style.display = 'block';

        fetch(`${settings.apiEndpoint}?search=${searchValue}`)
            .then(response => response.json())
            .then(data => {
                loadingIndicator.style.display = 'none';
                submitButton.disabled = false;

                if (data.success) {
                    resultContainer.style.display = 'block';
                    resultContainer.innerHTML += `
        <div class="card">
            ${data.data ? `
                <div class="gps-check-data-row"><span class="gps-check-data-label">${settings.numberLabel}:</span><span class="gps-check-data-value">${data.data.Inum}</span></div>
                <div class="gps-check-data-row"><span class="gps-check-data-label">${settings.balanceLabel}:</span><span class="gps-check-data-value">${data.data.Balance} ${data.data.Currency}</span></div>
                <button class="button sec-btn form__btn" type="button" data-action="recharge">Recharge SIM</button>
            ` : ''}
        </div>
        <hr class="result-divider">
    `;
                    if (data.data) {
                        resultContainer.querySelector('button[data-action="recharge"]').addEventListener('click', () => {
                            window.open(`https://beachsim.de/products/gps-sim-card-recharge?simCode=${searchValue}`, '_blank');
                        });
                    }
                    updateUrlWithLookup(searchValue);
                    createNewQueryForm();
                    createCopyUrlButton();
                } else {
                    showError(data.message);
                }
            })
            .catch(error => {
                loadingIndicator.style.display = 'none';
                submitButton.disabled = false;
                showError(settings.fetchErrorPrefix + error.message);
            });
    }


    balanceForm.addEventListener('submit', function(e) {
        e.preventDefault();

        errorMessage.style.display = 'none';
        resultContainer.style.display = 'none';

        const searchValue = searchInput.value.trim();

        if (!searchValue) {
            showError(settings.emptyInputError);
            return;
        }

        submitButton.disabled = true;
        loadingIndicator.style.display = 'block';

        fetch(`${settings.apiEndpoint}?search=${searchValue}`)
            .then(response => response.json())
            .then(data => {
                loadingIndicator.style.display = 'none';
                submitButton.disabled = false;

                if (data.success) {
                    resultContainer.style.display = 'block';
                    resultContainer.innerHTML += `
        <div class="card">
            ${data.data ? `
                <div class="gps-check-data-row"><span class="gps-check-data-label">${settings.numberLabel}:</span><span class="gps-check-data-value">${data.data.Inum}</span></div>
                <div class="gps-check-data-row"><span class="gps-check-data-label">${settings.balanceLabel}:</span><span class="gps-check-data-value">${data.data.Balance} ${data.data.Currency}</span></div>
                <button class="button sec-btn form__btn" type="button" data-action="recharge">Recharge SIM</button>
            ` : ''}
        </div>
        <hr class="result-divider">
    `;
                    if (data.data) {
                        resultContainer.querySelector('button[data-action="recharge"]').addEventListener('click', () => {
                            window.open(`https://beachsim.de/products/gps-sim-card-recharge?simCode=${searchValue}`, '_blank');
                        });
                    }
                    updateUrlWithLookup(searchValue);
                    createNewQueryForm();
                    createCopyUrlButton();
                } else {
                    showError(data.message);
                }
            })
            .catch(error => {
                loadingIndicator.style.display = 'none';
                submitButton.disabled = false;
                showError(settings.fetchErrorPrefix + error.message);
            });
    });

    function displaySuccessResult(data) {
        resultContainer.style.display = 'block';
        statusInfo.innerHTML = `
      <div class="gps-check-success-badge">${settings.successBadgeText}</div>
      <p>${data.message}</p>
    `;
        let content = '';
        if (data.data) {
            const balanceData = data.data;
            content += createDataRow(settings.numberLabel, balanceData.Inum);
            content += createDataRow(settings.balanceLabel, `${balanceData.Balance} ${balanceData.Currency}`);
            content += createDataRow(settings.prepaidLabel, balanceData.Prepayed ? settings.yesText : settings.noText);
            content += createDataRow(settings.blockedLabel, balanceData.Blocked ? settings.yesText : settings.noText);
        }
        resultContent.innerHTML = content;
    }

    function showError(message) {
        errorMessage.style.display = 'block';
        errorMessage.innerHTML = `
      <div class="gps-check-error-badge">${settings.errorBadgeText}</div>
      <p>${message}</p>
    `;
    }

    function createDataRow(label, value) {
        return `
      <div class="gps-check-data-row">
          <span class="gps-check-data-label">${label}:</span>
          <span class="gps-check-data-value">${value}</span>
      </div>
    `;
    }

    function formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        return date.toLocaleString();
    }
});